"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get the index (or 0) for the end of given token. Useful to not clutter code
 * with conditionals
 *
 * @param token
 */
const endOfToken = (token) => {
    if (!token) {
        return 0;
    }
    return token.offset + token.text.length;
};
exports.default = endOfToken;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5kT2ZUb2tlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90b2tlbml6ZS9lbmRPZlRva2VuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUE7Ozs7O0dBS0c7QUFDSCxNQUFNLFVBQVUsR0FBRyxDQUFDLEtBQXdCLEVBQVUsRUFBRTtJQUN0RCxJQUFJLENBQUMsS0FBSyxFQUFFO1FBQ1YsT0FBTyxDQUFDLENBQUM7S0FDVjtJQUVELE9BQU8sS0FBSyxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztBQUMxQyxDQUFDLENBQUM7QUFFRixrQkFBZSxVQUFVLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBUb2tlbiB9IGZyb20gJ21vbyc7XG5cbi8qKlxuICogR2V0IHRoZSBpbmRleCAob3IgMCkgZm9yIHRoZSBlbmQgb2YgZ2l2ZW4gdG9rZW4uIFVzZWZ1bCB0byBub3QgY2x1dHRlciBjb2RlXG4gKiB3aXRoIGNvbmRpdGlvbmFsc1xuICpcbiAqIEBwYXJhbSB0b2tlblxuICovXG5jb25zdCBlbmRPZlRva2VuID0gKHRva2VuOiBUb2tlbiB8IHVuZGVmaW5lZCk6IG51bWJlciA9PiB7XG4gIGlmICghdG9rZW4pIHtcbiAgICByZXR1cm4gMDtcbiAgfVxuXG4gIHJldHVybiB0b2tlbi5vZmZzZXQgKyB0b2tlbi50ZXh0Lmxlbmd0aDtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGVuZE9mVG9rZW47XG4iXX0=